import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GiftCardComponent } from './components/gift-card/gift-card.component';
import { GiftCardRoutingModule } from './gift-card-routing.module';
import { AdminSharedModule } from '../../../shared/admin-shared.module';

@NgModule({
  imports: [CommonModule, GiftCardRoutingModule, AdminSharedModule],
  declarations: [GiftCardComponent],
  exports : [GiftCardComponent]
})
export class GiftCardModule {}
